import React, { Component } from 'react';
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import get from 'lodash/get';
import Auth from 'shared/Auth';

class SelectItem extends Component {
  state = {
    disabled: false,
    value: '',
    defaultOption: this.props.response || '',
    options: this.props.items || [],
    drowDownPlaceholder: get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Choisir' : 'Select an option',
  };

  onChange = (option) => {
     ('onChange');
    
    this.setState({
      value: get(option, 'value'),
      defaultOption: option
    });

    const onChange = this.props.onChange;

    if (onChange) {
      onChange(get(option, 'value'));
    }
  }

  render() {
    return (
      <Dropdown
        onChange={this.onChange}
        className="signup-form__form-control"
        options={this.state.options}
        value={this.state.defaultOption}
        placeholder={`${this.state.drowDownPlaceholder}`}/>
    )
  }
}

export default SelectItem;


// WEBPACK FOOTER //
// ./src/ui/Select.js